module.exports = __webpack_public_path__ + "static/media/34-6.4d75faa0.mp3";